<template>
    <a v-if="email" :href="'mailTo:' + email" target="_blank" class="underline">{{ email }}</a>
    <span v-else></span>
</template>
<script>
export default {
    props: ['email'],
};
</script>
